define('home/utils/layoutUtils',[
    'jquery',
    'underscore',
], function (
    $,
    _
) {
    'use strict';

    var getNavHeight = _.memoize(function () {
        return $('[data-role=nav-view]').outerHeight();
    });

    var exports = {};

    /**
     * Determines if a element is even partially visible in the viewport, excluding the nav bar.
     *
     * @param {jQuery} $el The jQuery-wrapped element to check for viewport visibility
     * @returns {boolean} `true` if any part of $el is visible in the viewport, `false` otherwise.
     */
    exports.isElementInViewport = function ($el) {
        var navHeight = getNavHeight();
        var rect = $el[0].getBoundingClientRect();

        // This coercion to 0 is because matchMedia().matches
        // always returns false for negative values
        var top = rect.top > 0 ? rect.top : 0;
        var left = rect.left > 0 ? rect.left : 0;

        return (
            rect.bottom >= navHeight &&
            rect.right >= 0 &&
            window.matchMedia('(min-height: ' + top + 'px) and (min-width: ' + left + 'px)').matches
        );
    };

    exports.isNarrowLayout = function () {
        return !window.matchMedia('(min-width: 480px)').matches;
    };

    return exports;
});

